import React from 'react';
import type { DataContentProps } from '@ecosystem/newron-core';

function SpecialStatic(_: DataContentProps) {
  return <div className="bg-purple-100 rounded p-6">I'm a special UI element provided from the market MFE</div>;
}

export { SpecialStatic };
